<template>
  <div
    class="side-panel-wrapper"
    :class="{
      'show-from-left': showFromLeft,
      'show-from-right': showSidePanel,
      hiding: !showSidePanel,
    }"
    :style="{
      width: width,
      height: height,
    }"
  >
    <div
      v-click-outside="vsoConfig"
      class="side-panel-container"
    >
      <slot />
    </div>
  </div>
</template>

<script>
import vClickOutside from 'click-outside-vue3';

export default {
  name: 'SidePanel',
  directives: {
    clickOutside: vClickOutside.directive,
  },
  props: {
    width: {
      type: String,
      default: '',
    },
    height: {
      type: String,
      default: '',
    },
    hiding: Boolean,
    showSidePanel: {
      type: Boolean,
      default: false,
    },
    showFromLeft: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['close'],
  data() {
    return {
      disappearing: false,
      vsoConfig: {
        middleware: this.middleware,
        handler: this.close,
        events: ['mousedown'],
      },
    };
  },
  methods: {
    close(e) {
      this.$emit('close', e);
      this.disappearing = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.side-panel-wrapper {
  position: absolute;
  right: 0;
  background-color: #ffffff;
  z-index: 100;
  box-shadow: 0px 0px var(--px7) var(--px2) rgba(0, 0, 0, 0.25);
  transform: translateX(var(--px950));
  @media only screen and (max-width: 500px) {
    width: var(--px350) !important;
  }
  @media only screen and (max-width: 420px) {
    width: 100% !important;
  }
  &.hiding {
    transform: translateX(var(--px950));
    transition: ease-out 0.3s;
  }
  &.show-from-left {
    animation: slide-from-left ease-out 0.3s;
    left: 0;
  }
  &.show-from-right {
    transform: translateX(0);
    transition: ease-out 0.3s;
  }
  .side-panel-container {
    height: 100%;
    overflow-y: auto;
  }
}
</style>
